import { render } from "./Propertytypes.vue?vue&type=template&id=5a9b3836&scoped=true"
import script from "./Propertytypes.vue?vue&type=script&lang=js"
export * from "./Propertytypes.vue?vue&type=script&lang=js"

import "./Propertytypes.vue?vue&type=style&index=0&id=5a9b3836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9b3836"]])

export default __exports__